angular.module('SpidApp')

.constant('OptionAffranchissementDestinationAdapterConfig', {
  name : 'OptionAffranchissementDestination',
  fields : [
    {
    	local   : 'type_option',
    	distant : 'type_option'
    }, {
    	local   : 'code_destination',
    	distant : 'code_destination'
    }, {
    	local   : 'code_affranchissement',
    	distant : 'code_affranchissement'
    }, {
    	local   : 'lib_long',
    	distant : 'lib_long'
    }, {
    	local   : 'is_mandatory',
    	distant : 'is_mandatory'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }
  ]
})
